import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Input, Button, DatePicker, message } from "antd";
import "./request-demo.style.less";
import * as actionCreators from '../../actions/landing-page-action/index';

const RequestDemo = (props) => {
  const dispatch = useDispatch();
  const [companyName, setCompanyName] = useState("");
  const [contactPersonName, setContactPersonName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [demoDate, setDemoDate] = useState("");

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const handleRequestDemo = () => {
      if(companyName && phoneNumber && email && contactPersonName) {
          const formData = new FormData();
      
          formData.append("company", companyName);
          formData.append("phone_number", phoneNumber);
          formData.append("email", email);
          formData.append("name", contactPersonName);
        //   formData.append("date", demoDate);
      
          dispatch(actionCreators.requestADemo(formData))
          props.onClose();

      } else {
          message.info('Please fill all the fields!')
      }
  };

  return (
    <div className="request-demo-modal-container">
      <p>Request a Demo</p>
      <div className="at-form-section">
        <Form name="nest-messages" validateMessages={validateMessages}>
          <div className="at-input-fields-section">
            <Input
              required
              placeholder="Company Name"
              onChange={(e) => setCompanyName(e.target.value)}
            />

            <Input
              required
              placeholder="Contact Person Name"
              onChange={(e) => setContactPersonName(e.target.value)}
            />
            <Form.Item
              style={{
                width: "80%",
                margin: "1.5% 0",
              }}
              name={["user", "email"]}
              rules={[{ type: "email", label: "Email", required: "true" }]}
            >
              <Input
                style={{ height: "4rem" }}
                required
                rules={[{ required: true }]}
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>
            <Input
              required
              type="number"
              placeholder="Phone Number"
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            {/* <DatePicker
              style={{
                width: "80%",
                height: "4rem",
                margin: "1.5% 0",
              }}
              placeholder="Select Demo Date"
              onChange={(date, dateString) => setDemoDate(date)}
            /> */}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                onClick={handleRequestDemo}
              >
                Submit
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RequestDemo;
